import LogoColor from '../../../assets/images/logoOffical.png';
import IconFacebook from '../../../assets/icons/ic-baseline-facebook.svg';
import IconInstagram from '../../../assets/icons/ic-instagram-fill.svg';
import ImageFooter from '../../../assets/images/img-footer.png';
import ImageHeaderMobile from '../../../assets/images/img-header-mobile.png';
import { Link } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import Tiktok from '../../../assets/icons/tiktok-footer.svg';
import Youtube from '../../../assets/icons/youtube-footer.svg';
import useDevice from 'utils/use-device';

const Footer = () => {
  const { t } = useTranslation('header');

  const { isMobile } = useDevice();

  return (
    <div className="relative bg-footer py-9 mt-9 xl:mt-[80px]">
      <div className="hidden xl:block absolute bottom-0 left-0 right-0">
        <img src={ImageFooter} alt="footer" className="w-full" />
      </div>

      <div className="block xl:hidden absolute bottom-0 left-0 right-0">
        <img src={ImageHeaderMobile} alt="header" className="w-full" />
      </div>

      <div className="relative z-[1] flex flex-col items-center">
        <img src={LogoColor} alt="logo color" className="w-[140px] h-[140px] object-contain" />

        <div className="flex items-center gap-x-4 mt-4 xl:mt-7">
          <a
            href="https://www.facebook.com/profile.php?id=100083419447159"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={IconFacebook} alt="facebook" />
          </a>
          <a
            href="https://www.instagram.com/tanlocrestaurant/?igshid=OGQ5ZDc2ODk2ZA%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={IconInstagram} alt="instagram" />
          </a>
          <a
            href="https://www.tiktok.com/@tanlocseafood_restaurant"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Tiktok} alt="Tiktok" />
          </a>
          <a
            href="https://www.youtube.com/@TanLocSeafood_Restaurant/featured"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={Youtube} alt="Youtube" />
          </a>
        </div>

        <ul className="mt-4 xl:mt-7 flex flex-col xl:flex-row items-center gap-y-5 xl:gap-x-9 text-primary text-[14px] font-semibold uppercase">
          <li className="cursor-pointer">
            <Link to="aboutUs" hashSpy={true} spy={true} smooth={true} offset={isMobile ? 0 : -90}>
              {t('navigation.introduction')}
            </Link>
          </li>
          <li className="cursor-pointer">
            <Link to="menu" hashSpy={true} spy={true} smooth={true} offset={isMobile ? 0 : -90}>
              {t('navigation.menu')}
            </Link>
          </li>
          <li className="cursor-pointer">
            <Link to="feedback" hashSpy={true} spy={true} smooth={true} offset={isMobile ? 0 : -90}>
              {t('navigation.feedback')}
            </Link>
          </li>
          <li className="cursor-pointer">
            <Link to="service" hashSpy={true} spy={true} smooth={true} offset={isMobile ? 0 : -90}>
              {t('navigation.service')}
            </Link>
          </li>
          <li className="cursor-pointer">
            <Link
              activeClass="border-b border-white pb-1"
              to="news"
              hashSpy={true}
              spy={true}
              smooth={true}
              offset={-90}
            >
              {t('navigation.news')}
            </Link>
          </li>
          <li className="cursor-pointer">
            <Link
              to="contactUs"
              hashSpy={true}
              spy={true}
              smooth={true}
              offset={isMobile ? 0 : -90}
            >
              {t('navigation.contact')}
            </Link>
          </li>
        </ul>

        <p className="text-blue-200 text-[10px] xl:text-[12px] text-center mt-4 xl:mt-7 w-[55%] xl:w-full">
          Copyright © 2023 Designed and Developed by Central Tech Solutions.
        </p>
      </div>
    </div>
  );
};

export default Footer;
